import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { LinkElement } from '@els/els-react--link-element';
import externalUrl from '@Utils/ExternalUrl';
import Catalyst from '@Services/Catalyst';

function CitedCountLink({ citedCount, citedUrl, 'data-e2e': dataE2e, ...linkProps }) {
  const citedByUrl = externalUrl(citedUrl);
  const [href, setHref] = useState(citedByUrl);

  useEffect(() => {
    let shouldUpdate = true;

    async function updateHref() {
      setHref((currentHref) => (currentHref !== citedByUrl ? citedByUrl : currentHref));
      const updatedUrl = await Catalyst.appendVisitorIDToUrl(citedByUrl);
      if (shouldUpdate) {
        setHref(updatedUrl);
      }
    }

    updateHref();

    return () => {
      shouldUpdate = false;
    };
  }, [citedByUrl]);

  return (
    <LinkElement data-e2e={dataE2e} {...linkProps} href={href} isExternal>
      Cited <b>{citedCount}</b> {Number(citedCount) === 1 ? 'time' : 'times'}
    </LinkElement>
  );
}

CitedCountLink.propTypes = {
  citedCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  citedUrl: PropTypes.string,
  'data-e2e': PropTypes.string.isRequired,
};

export default CitedCountLink;
